{
  "schemaVersion": 1,
  "slug": "google-slides",
  "name": "Google Slides",
  "description": "Read and update Google Slides presentations.",
  "categories": [
    "content",
    "productivity"
  ],
  "featured": true,
  "branding": {
    "logoUrl": "/brands/apps/google-slides.svg"
  },
  "urlPatterns": [
    "https://slidesmcp.googleapis.com/*",
    "https://docs.google.com/presentation/*"
  ],
  "docsUrl": "https://developers.google.com/workspace/slides/api/reference/mcp",
  "setupPrerequisite": {
    "title": "Google Developer Preview access required",
    "description": "Google must register both the Workspace email used to authorize Paperclip and the Google Cloud project that owns the OAuth client. Registration is limited to those emails and projects; it does not enable unrelated Paperclip customers.",
    "steps": [
      "Apply with the Workspace email that will sign in and the Google Cloud project that owns the OAuth client.",
      "Wait for the Google Group notification and then Google's final project-registration email, usually within a couple of days.",
      "Add every additional tester email or Cloud project through Google's member request forms before connecting."
    ],
    "actionLabel": "Apply or verify Developer Preview enrollment",
    "actionUrl": "https://developers.google.com/workspace/preview"
  },
  "redirectConstraints": "https-or-loopback-http",
  "methods": [
    {
      "key": "paperclip-read",
      "label": "Connect with Paperclip",
      "transport": "mcp_remote",
      "auth": "oauth",
      "oauthStrategy": "paperclip_cloud_connector",
      "connectorProfile": "slides.read",
      "capabilityProfile": {
        "key": "read",
        "label": "Read only",
        "description": "Read presentation slides and content."
      },
      "grantKinds": [
        "user",
        "organization"
      ],
      "ownershipModes": [
        "platform_shared"
      ],
      "whenToUse": "Use Paperclip-managed OAuth for read-only Slides access.",
      "defaults": {
        "serverUrl": "https://slidesmcp.googleapis.com/mcp/v1",
        "scopesHint": [
          "https://www.googleapis.com/auth/drive.readonly",
          "https://www.googleapis.com/auth/presentations.readonly"
        ]
      },
      "guidanceMd": "Connect Google Slides to read presentations.",
      "warnings": [
        "Google Workspace MCP servers are in Developer Preview."
      ],
      "riskTier": "S3"
    },
    {
      "key": "customer-read-oauth",
      "label": "Use your own Google OAuth app",
      "transport": "mcp_remote",
      "auth": "oauth",
      "capabilityProfile": {
        "key": "read",
        "label": "Read only",
        "description": "Read presentation slides and content."
      },
      "grantKinds": [
        "user",
        "organization"
      ],
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Use a customer-owned OAuth client for read-only Slides access.",
      "defaults": {
        "serverUrl": "https://slidesmcp.googleapis.com/mcp/v1",
        "authorizationEndpoint": "https://accounts.google.com/o/oauth2/v2/auth",
        "tokenEndpoint": "https://oauth2.googleapis.com/token",
        "metadataUrl": "https://accounts.google.com/.well-known/openid-configuration",
        "scopesHint": [
          "https://www.googleapis.com/auth/drive.readonly",
          "https://www.googleapis.com/auth/presentations.readonly"
        ],
        "oauthAuthorizationParams": {
          "access_type": "offline",
          "prompt": "consent"
        }
      },
      "guidanceMd": "Enable the Drive, Slides, and Slides MCP APIs, then register Paperclip's callback URI.",
      "consoleLinks": {
        "register": "https://console.cloud.google.com/auth/clients",
        "docs": "https://developers.google.com/workspace/guides/configure-mcp-servers"
      },
      "warnings": [
        "Google Workspace MCP servers are in Developer Preview."
      ],
      "riskTier": "S3"
    },
    {
      "key": "paperclip-write",
      "label": "Connect with Paperclip",
      "transport": "mcp_remote",
      "auth": "oauth",
      "oauthStrategy": "paperclip_cloud_connector",
      "connectorProfile": "slides.write",
      "capabilityProfile": {
        "key": "write",
        "label": "Read & edit",
        "description": "Read and update presentations."
      },
      "grantKinds": [
        "user",
        "organization"
      ],
      "ownershipModes": [
        "platform_shared"
      ],
      "whenToUse": "Use Paperclip-managed OAuth to read and update Slides.",
      "defaults": {
        "serverUrl": "https://slidesmcp.googleapis.com/mcp/v1",
        "scopesHint": [
          "https://www.googleapis.com/auth/drive.readonly",
          "https://www.googleapis.com/auth/drive.file",
          "https://www.googleapis.com/auth/presentations"
        ]
      },
      "guidanceMd": "Connect Google Slides to read and update presentations.",
      "warnings": [
        "Presentation updates require approval.",
        "Google Workspace MCP servers are in Developer Preview."
      ],
      "riskTier": "S4"
    },
    {
      "key": "customer-write-oauth",
      "label": "Use your own Google OAuth app",
      "transport": "mcp_remote",
      "auth": "oauth",
      "capabilityProfile": {
        "key": "write",
        "label": "Read & edit",
        "description": "Read and update presentations."
      },
      "grantKinds": [
        "user",
        "organization"
      ],
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Use a customer-owned OAuth client to read and update Slides.",
      "defaults": {
        "serverUrl": "https://slidesmcp.googleapis.com/mcp/v1",
        "authorizationEndpoint": "https://accounts.google.com/o/oauth2/v2/auth",
        "tokenEndpoint": "https://oauth2.googleapis.com/token",
        "metadataUrl": "https://accounts.google.com/.well-known/openid-configuration",
        "scopesHint": [
          "https://www.googleapis.com/auth/drive.readonly",
          "https://www.googleapis.com/auth/drive.file",
          "https://www.googleapis.com/auth/presentations"
        ],
        "oauthAuthorizationParams": {
          "access_type": "offline",
          "prompt": "consent"
        }
      },
      "guidanceMd": "Enable the Drive, Slides, and Slides MCP APIs, then register Paperclip's callback URI.",
      "consoleLinks": {
        "register": "https://console.cloud.google.com/auth/clients",
        "docs": "https://developers.google.com/workspace/guides/configure-mcp-servers"
      },
      "warnings": [
        "Presentation updates require approval.",
        "Google Workspace MCP servers are in Developer Preview."
      ],
      "riskTier": "S4"
    }
  ]
}
